module.exports = __webpack_public_path__ + "8b8a4ac37c99b94ac4394d39930ee254.fbx";